import { Money } from '@libs/money/money.interfaces';
import { AnyProduct } from './product';

export interface PreCheckoutData {
    ProductGroups: ProductGroups | null;
    TotalPrice: Money;
}

interface ProductGroups {
    Ferry: FerryProductGroup | null;
}

export interface FerryProductGroup {
    Addons: FerryPreAddon[];
}

export interface FerryPreAddon {
    Id: string;
    Type: FerryPreAddonType;
    ImageUrl: string | null;
    Products: Product[];
    Valid?: boolean;
}

export interface Product {
    Product: AnyProduct;
    Options: Option[];
    MandatoryState: MandatoryState | null;
    OptionsIncludedInPrice?: Option[];
    Valid?: boolean;
}

export interface Option {
    Id: string;
    Title: string;
    Description?: string | null;
    ImageUrl?: string | null;
    Category: Category | null;
    Price: Money;
    Type: ValueType;
    Value?: any;
    IncludedInBasePrice?: number;
    Valid?: boolean;
    InfoMessages: string[] | null;
    Worth: Worth | null;
    Validations: Validation[] | null;
    ConnectedOptions: ConnectedOptions[] | null;
}

interface ConnectedOptions {
    // Target and check other addon
    Target: {
        Id: string;
        Type: ValueType;
        Value: any;
        ValidationType: ValidationType | null;
    };

    // Based on matching target, what is my own behavior.
    Behavior: BehaviorType;
}

export interface MandatoryState {
    Type: ValueType;
    Value: any;
    ValidationType: ValidationType | null;
    Message: string | null;
}

export interface Worth {
    Value: any;
    Description?: string | null;
}

export interface Validation {
    Value: any;
    ValidationType: ValidationType | null;
    Message: string | null;
}

export enum Category {
    Cabin,
    Seat,
}

export enum FerryPreAddonType {
    Accommodation,
    Cabin,
    Seat,
    Pet,
    Meal,
    Lounge,
}

enum BehaviorType {
    Required,
    Alternative,
}

export enum ValueType {
    Count,
    CountSelect,
    Boolean,
}

export enum ValidationType {
    Exact,
    Minimum,
    Maximum,
}

export interface SaveSelectionResponse {
    IsValid: boolean;
    Errors: SaveSelectionResponseError[];
}

interface SaveSelectionResponseError {
    Message: string;
    AddonId: string;
    OptionId: string | null;
}

export interface SaveSelectionRequest {
    SaveSelections: SaveSelections;
}

export interface SaveSelections {
    Ferry: FerrySaveSelection[];
}

export interface FerrySaveSelection {
    Addon: {
        Id: string;
        Type: FerryPreAddonType;
    };
    Product: AnyProduct;
    Options: OptionState[];
}

interface OptionState {
    Id: string;
    Value?: any;
}
